module.exports = __webpack_public_path__ + "media/images/playpass_logo_h_xsm-776f47b520575ae25a73bf06b89f2e1a.png";